import React, { Component } from 'react';
import { connect } from 'react-redux';
import { _LIST_PAGINATION_MODEL } from '../../../store/modules/app/models';
import { recommendStoreActions } from '../../../store/modules/recommend/store';
import {
  RECOMMEND_STORE_LIST_SEARCH_DATA_MODEL,
  RECOMMEND_STORE_LIST_SEARCH_OPTION_MODEL,
} from '../../../store/modules/recommend/store/models';
import RecommendStoreListWrap from '../../../views/recommend/store/list/RecommendStoreListWrap';

class RecommendStoreListContainer extends Component {
  componentDidMount() {
    this.initiate();
  }

  /**
   * 초기 데이터 불러오기
   */
  initiate = () => {
    const { setData } = this.props;

    this.getList({
      /**
       *  검색 옵션
       */
      searchOption: RECOMMEND_STORE_LIST_SEARCH_OPTION_MODEL,
      /**
       *  pagination
       */
      pagination: _LIST_PAGINATION_MODEL,
    });

    /**
     * 검색 박스 초기화
     */
    setData({
      path: ['recommendStoreList', 'searchData'],
      value: RECOMMEND_STORE_LIST_SEARCH_DATA_MODEL,
    });
  };

  /**
   * 리스트 불러오기
   */
  getList = async (data) => {
    const { getRecommendStoreList, recommendStoreList } = this.props;
    const { searchOption, sortOption, pagination } = recommendStoreList;

    getRecommendStoreList({
      searchOption,
      sortOption,
      pagination,
      ...data,
    });
  };

  render() {
    const { recommendStoreList, setData } = this.props;

    return <RecommendStoreListWrap recommendStoreList={recommendStoreList} setData={setData} getList={this.getList} />;
  }
}

const mapStateToProps = (state) => {
  return {
    recommendStoreList: state.recommendStore.recommendStoreList,
  };
};

const mapDispatchToProps = {
  setData: recommendStoreActions.setData,
  getRecommendStoreList: recommendStoreActions.getRecommendStoreList,
};

export default connect(mapStateToProps, mapDispatchToProps)(RecommendStoreListContainer);
